import React, { FC, useEffect, useState } from 'react';
import { LandscapeAddProjectsAddSupporterTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchBuyers } from '../../../store/buyerAPI/buyer/reducers/buyer.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { ProjectOrganizationSaveRequestDto } from '../../../store/tradeAPI/projectSupporter/dto/request/project-organization-save-request.dto';
import { useNavigate, useParams } from 'react-router-dom';
import { getUUID } from '../../../utils/UUID';
import { ProjectOrganizationRelationType } from '../../../store/tradeAPI/projectSupporter/project-organization-relation-type';
import { saveProjectSupporters } from '../../../store/tradeAPI/projectSupporter/reducers/project-supporters.slice';

interface LandscapeAddProjectsAddSupporterPageProps {}

const LandscapeAddProjectsAddSupporterPage: FC<
  LandscapeAddProjectsAddSupporterPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id, projectId, relationType } = useParams();

  const navigate = useNavigate();

  const { buyers, status } = useSelector(
    (state: RootState) => state.buyerSlice
  );

  const { status: supporterStatus } = useSelector(
    (state: RootState) => state.projectSupporterSlice
  );

  const [selectedBuyer, setSelectedBuyer] = useState<BuyerResponseDto>(
    {} as BuyerResponseDto
  );

  useEffect(() => {
    dispatch(fetchBuyers());
  }, [dispatch]);

  const handleSubmit = async () => {
    const request: ProjectOrganizationSaveRequestDto = {
      contributionAmount: 0,
      id: getUUID(),
      isSupportingProject: false,
      organizationId: selectedBuyer.id,
      projectId: projectId!,
      projectSupportId: '',
      published: true,
      relationType:
        ProjectOrganizationRelationType[
          relationType as keyof typeof ProjectOrganizationRelationType
        ],
    };

    await dispatch(saveProjectSupporters(request));

    if (relationType === ProjectOrganizationRelationType.Initiator) {
      navigate(
        `/landscapes/edit/${id}/projects/add-project/${projectId}/general-information`
      );
    } else if (relationType === ProjectOrganizationRelationType.Supporters) {
      navigate(
        `/landscapes/edit/${id}/projects/add-project/${projectId}/supporters`
      );
    }
  };

  if (status === 'loading' || supporterStatus === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeAddProjectsAddSupporterTemplate
      buyers={buyers ?? []}
      setSelectedBuyer={setSelectedBuyer}
      handleOnSubmit={handleSubmit}
    />
  );
};

export default LandscapeAddProjectsAddSupporterPage;
